import { Routes } from '@angular/router';
import { RewardsComponent } from './rewards.component';
import { ForYouComponent } from './for-you/for-you.component';
import { FavoritesComponent } from './favorites/favorites.component';
import { ExploreComponent } from './explore/explore.component';
import { BrandsComponent } from './brands/brands.component';
import { BrandProductsComponent } from './brand-products/brand-products.component';
import { RewardProductsPageComponent } from './reward-products-page/reward-products-page.component';

export const routes: Routes = [
  {
    path: '',
    component: RewardsComponent,
    children: [
      { path: '', redirectTo: 'for-you', pathMatch: 'full' },
      { path: 'for-you', component: ForYouComponent },
      { path: 'favorites', component: FavoritesComponent },
      { path: 'explore', component: ExploreComponent }
    ]
  },
  {
    path: 'brands',
    data: { breadcrumb: 'rewards.browseBrands', title: 'rewards.rewards' },
    component: BrandsComponent
  },
  {
    path: 'brands/:id',
    data: { breadcrumb: 'rewards.browseBrands', title: 'rewards.rewards' },
    component: BrandProductsComponent
  },
  {
    path: 'featured',
    data: { breadcrumb: 'rewards.featured', title: 'rewards.rewards', rewardsListType: 'featured' },
    component: RewardProductsPageComponent
  },
  {
    path: 'popular-in-community',
    data: {
      breadcrumb: 'rewards.popularInYourCommunity',
      title: 'rewards.rewards',
      rewardsListType: 'popular-in-community'
    },
    component: RewardProductsPageComponent
  },
  {
    path: 'product/:productId',
    loadChildren: () => import('./product/product-routes').then(m => m.routes),
    data: { title: 'rewards.rewards', breadcrumb: 'replacer=productName' }
  }
];
